module.exports = "<footer>\r\n    <span>Time Tracker &#169; {{currentYear}} Diatom Enterprises {{deploymentVersion}}</span>\r\n</footer>"